module.exports = __webpack_public_path__ + "static/workflow-chart-f234d8013c182abae6c42ab14f8d9f69.png";